import { Products } from './ids';
import {
  Product,
  ProductFamily,
  ProductInterval,
  ProductName,
  ProductShortName,
} from '../types';
import {
  businessClassFeaturesVersion2,
  businessClassFeaturesVersion3,
  businessClassFeaturesVersion3x3,
  enterpriseFeatures,
} from '../features';

export const enterpriseProducts: Product[] = [
  {
    id: Products.Enterprise.v1,
    shortName: ProductShortName.Enterprise,
    name: ProductName.Enterprise,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Enterprise,
    price: 0,
    features: enterpriseFeatures,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.BCPO.v2,
    shortName: ProductShortName.BusinessClass2PO,
    name: ProductName.BusinessClass2PO,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 0,
    features: businessClassFeaturesVersion2,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
    upgrade: true,
  },
  {
    id: Products.BCPO.v3,
    shortName: ProductShortName.BusinessClass3PO,
    name: ProductName.BusinessClass3PO,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 0,
    features: businessClassFeaturesVersion3,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.BCPO.v3_1,
    shortName: ProductShortName.BusinessClass3x1PO,
    name: ProductName.BusinessClass3x1PO,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 0,
    features: businessClassFeaturesVersion3,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.Enterprise.v1_1,
    shortName: ProductShortName.Enterprise1x1TieredPricing,
    name: ProductName.Enterprise1x1,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Enterprise,
    price: 0,
    features: enterpriseFeatures,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.Enterprise.v1_2,
    shortName: ProductShortName.Enterprise1x2SiteLicense,
    name: ProductName.Enterprise1x2,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Enterprise,
    price: 0,
    features: enterpriseFeatures,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.BCPO.v3_3,
    shortName: ProductShortName.BusinessClass3x3PO,
    name: ProductName.BusinessClass3x3PO,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 0,
    features: businessClassFeaturesVersion3x3,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.Enterprise.v2_1,
    shortName: ProductShortName.Enterprise2x0TieredPricing,
    name: ProductName.Enterprise2x0,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Enterprise,
    price: 0,
    features: enterpriseFeatures,
    perUser: false,
    prebill: true,
    smartBill: false,
    current: true,
    hidden: true,
    purchaseOrder: true,
  },
  {
    id: Products.Enterprise.v2_2,
    shortName: ProductShortName.Enterprise2x1SiteLicense,
    name: ProductName.Enterprise2x1,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Enterprise,
    price: 0,
    features: enterpriseFeatures,
    perUser: false,
    prebill: true,
    smartBill: false,
    hidden: true,
    current: true,
    purchaseOrder: true,
  },
];
